import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Height } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import useStyles from "../../styles/navbar/TableHeadStyles";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  height: "65%",
  marginBottom: 40,
};

const LastChangesModal = ({ open, setOpen, last10Orders, orders }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={2}
        >
          <Typography variant="h6" gutterBottom>
            {t("lastChanges")}
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <TableContainer component={Paper} style={{ height: "95%"}}>
          <Table stickyHeader>
            <TableHead>
            <TableRow>
              <TableCell sx={{ bgcolor: "#E0DFD5" }}>{t("product")}</TableCell>
              <TableCell sx={{ bgcolor: "#E0DFD5" }}>BE</TableCell>
              <TableCell sx={{ bgcolor: "#E0DFD5" }}>{t("dateBeforeChange")}</TableCell>
              <TableCell sx={{ bgcolor: "#E0DFD5" }}>{t("dateModified")}</TableCell>
              <TableCell sx={{ bgcolor: "#E0DFD5" }}>{t("changeDate")}</TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
              {last10Orders.size > 0
                ? Array.from(last10Orders.entries()).map(
                    ([key, value], index) => {

                      const splitValue = value.split(",");
                      const dateChangedTo = splitValue[0];
                      let changeDate = splitValue[1];
                      changeDate = changeDate.substring(0,10)
                      const dateBeforeChange = splitValue[2];
                      const numberROw = splitValue[3];

                      return (
                        <TableRow key={index}>
                          <TableCell>
                            <Typography style={{ fontSize: 15, fontWeight: "bolder" }}>
                                {
                            orders[key][numberROw].custProductNoItem}
                            </Typography>
                            {"\n"}
                            <Typography style={{ color: "grey", fontSize: 14 }}>
                                {  orders[key][numberROw].ytransname}
                            </Typography>{" "}
                          </TableCell>
                     
                          <TableCell>
                            {orders[key][numberROw].be !== undefined
                              ? orders[key][numberROw].be
                              : ""}
                          </TableCell>
                          {/* <TableCell>"test"</TableCell> */}
                          <TableCell>{dateBeforeChange === "null" ? "-" : dateBeforeChange}</TableCell>
                          <TableCell>{dateChangedTo}</TableCell>
                          <TableCell>{changeDate}</TableCell>
                        </TableRow>
                      );
                    }
                  )
                : null}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <Button onClick={handleClose} variant="contained" sx={{ mt: 2 }}>
          Zamknij
        </Button> */}
      </Box>
    </Modal>
  );
};

export default LastChangesModal;
